import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../config/apiClient";
import { API } from "../config/apiConfig";
import { LoginBodyNetType, LoginResponseNetType } from "./NetTypes";

async function loginRequest(email: string, password: string) {
	return await apiClient.post(API.AUTH.LOGIN, { email, password }).then((res) => res.data);
}

export function useLogin() {
	return useMutation<LoginResponseNetType, AxiosError, LoginBodyNetType>({
		mutationFn: ({ email, password }: LoginBodyNetType) => {
			return loginRequest(email, password);
		}
	});
}
